module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Whilst practically every regiment of the British Army had at least one tour of duty here over the course of the war, 1915 saw the first appearance of the Canadian Expeditionary Force (CEF) and over the next three years they would be joined by units of Australians (AIF), South Africans (SAOEF) and New Zealanders (NZEF). After 1915, apart from the daily human attrition which accounted for thousands of casualties in a war which was essentially fought from two opposing trench lines, the sector remained undisturbed by major offensive actions until 1918. There were, however, two actions of note that took place between June and August 1916 and another in 1917.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f019-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-432e66c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/28_fm0311.vue
// module id = 141
// module chunks = 0